import { default as Endpoint } from '../../api/Endpoint';
import * as Constants from '../constants';

export function requestCatalogs() {
  return {
    type: Constants.REQUEST_CATALOGS
  };
}
export function receiveCatalogs(json, error) {
  return {
    type: Constants.RECEIVE_CATALOGS,
    data: json,
    error
  };
}
export function receiveUpdatedCatalog(json) {
  return {
    type: Constants.RECEIVE_UPDATED_CATALOG,
    data: json
  };
}

export function requestCreateCatalog() {
  return {
    type: Constants.REQUEST_CREATE_CATALOG
  };
}
export function receiveCreateCatalog(json, error) {
  return {
    type: Constants.RECEIVE_CREATE_CATALOG,
    data: json,
    error
  };
}

export function getCatalogs(options = {}) {
  const path = 'ecs/api/catalog';
  return new Endpoint(path, requestCatalogs, receiveCatalogs)
    .withOptions(options)
    .call();
}

export function createCatalog(formData, options = {}) {
  const path = 'ecs/api/catalog';
  return new Endpoint(path, requestCreateCatalog, receiveCreateCatalog)
    .withMethod('POST')
    .withBody(formData)
    .withOptions(options)
    .call();
}
